import { all, fork } from "redux-saga/effects"

//public
import AccountSaga from "./auth/register/saga"
import AuthSaga from "./auth/login/saga"
import ForgetSaga from "./auth/forgetpwd/saga"
import ProfileSaga from "./auth/profile/saga"
import LayoutSaga from "./layout/saga"
import verifyOtpSaga from "./auth/VerifyOtp/saga"
import verifyEmailOtpSaga from "./auth/VerifyEmailOtp/saga"
// PROFILE
import calculateCompletionSaga from "./auth/ProfileProgress/saga"
import AddProfilePhotoSaga from "./ProfilePhoto/saga"
//Employee
import EmployeeSaga from "./Employee/saga"
import CustomerSaga from "./Customer/saga"
import LeadSaga from "./Leads/saga"
import Policy from "./Policy/saga"
import PaymentGateway from "./PaymentGetway/saga"
import fileUploadSaga from "./Bulk-Upload/saga"
import CustomFieldSaga from "./CustomFields/Saga"
// Google Auth Saga

import DashboardSaga from "./Dashboard/saga";
import GloginSaga from "./auth/GoogleAuth/saga";
import AccessProfileSaga from "./auth/Access/saga";
import CrossSellSaga from "./Cross-sell/saga";
import UpSellSaga from "./upSell/saga";
import ClaimSaga from "./ClaimForm/saga";
import RenewalSaga from "./RenewalTracking/saga";
import targetSaga from "./Target/saga";
import InsuranceNeedSaga from "./CalculateInsuranceNeed/saga";
import ReferenceSaga from "./References/Saga";
//Notifications

import Notification from "./notifications/saga";

// Payment Gateway

// Mutual Fund
import mutualFundSaga from "./MutualFund/saga"

import QuoteSaga from "./Quote/saga";


//Super User Saga
import SuperUserAuthSaga from "./SuperAdmin/Authentication/Login/saga";
import SuperUsers from "./SuperAdmin/Authentication/Users/saga"
import KnowledgeCenterSaga from "./SuperAdmin/KnowledgeCenter/saga"
import VehicleMasterSaga from "./SuperAdmin/VehicleMaster/saga"

import SuperAdminLOB from "./SuperAdmin/Lob-SubLob-company-income/saga"
import ManageRtoSaga from "./SuperAdmin/ManageRTO/Saga"
import ManageIncomeSaga from "./SuperAdmin/ManageIncomeRange/Saga"
import ManageMarketingToolsSaga from "./SuperAdmin/MarketingTools/Saga"
import mainKnowledgeCenterSaga from "./KnowledgeCenter/saga"
import NdaAgreementSaga from "./NdaAgreement/Saga"
import AdminNdaAgreementSaga from "./SuperAdmin/NdaAgreement/sagas"
import sendWhatsAppMsgSaga from "./SuperAdmin/SendWhatsAppMsg/sagas"
import ReportOtpSaga from "./ReportOtp/Sagas"

export default function* rootSaga() {
  yield all([
    //public
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(LayoutSaga),
    fork(verifyOtpSaga),
    fork(verifyEmailOtpSaga),
    fork(calculateCompletionSaga),
    fork(EmployeeSaga),
    fork(LeadSaga),
    fork(CustomerSaga),
    fork(AddProfilePhotoSaga),
    fork(GloginSaga),
    fork(Policy),
    fork(PaymentGateway),
    fork(fileUploadSaga),
    fork(CustomFieldSaga),
    fork(DashboardSaga),
    fork(AccessProfileSaga),
    fork(CrossSellSaga),
    fork(UpSellSaga),
    fork(ClaimSaga),
    fork(RenewalSaga),
    fork(Notification),
    fork(InsuranceNeedSaga),
    fork(targetSaga),
    fork(SuperUserAuthSaga),
    fork(SuperUsers),
    fork(KnowledgeCenterSaga),
    fork(VehicleMasterSaga),
    fork(SuperAdminLOB),
    fork(ManageRtoSaga),
    fork(ManageIncomeSaga),
    fork(ManageMarketingToolsSaga),
    fork(mainKnowledgeCenterSaga),
    fork(NdaAgreementSaga),
    fork(AdminNdaAgreementSaga),
    fork(sendWhatsAppMsgSaga),
    fork(ReportOtpSaga),
    fork(ReferenceSaga),
    fork(mutualFundSaga),
    fork(QuoteSaga),
  ])
}
